export enum AsyncOpState {
  Untouched = "Untouched",
  Changed = "Changed",
  Saving = "Saving",
  Success = "Success",
  Error = "Error",
}
